import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import {
    Button,
    Box,
    InputAdornment,
    Card,
    CardContent,
    Grid,
    Typography,
    TextField,
    InputLabel,
    MenuItem,
    FormControl,
    Select
} from '@mui/material';
import { useDeadline } from "../../../contexts/DeadlineContext";
const PayTabOne = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const { abstractHomeSetup } = useDeadline();

    const [settings, setPyamentSettings] = useState({
        PAYTAB_COUNTRY_ONE: '',
        PAYTAB_MERCHANT_EMAIL_ONE: '',
        PAYTAB_SECRET_KEY_ONE: '',
        PAYTAB_MERCHANT_ID_ONE: '',
        PAYTAB_STATUS_ONE: '',
        PAYTAB_MODE_ONE: '',
        PAYTAB_CURRENCY_ONE: "",
        PAYTAB_TAX_ONE: "",
        BANK_STATUS_ONE: "",
        CASH_STATUS_ONE: "",
        FREE_STATUS_ONE: "",
    });

    useEffect(() => {
        axios.get(`/api/get-setting/${eventid}`)
            .then(response => {
                setPyamentSettings(response.data.settings || {});
            })
            .catch(error => {
                console.error('Error fetching email settings:', error);
            });
    }, [eventid]);

    //   const handleChange = (event) => {
    //     const { name, value } = event.target;
    //     setPyamentSettings(prev => ({
    //       ...prev,
    //       [name]: value
    //     }));
    //   };
    const handleChange = (event) => {
        const { name, value } = event.target;

        if (name === "PAYTAB_COUNTRY_ONE") {
            let currency = "";
            switch (value) {
                case "SAU": currency = "SAR"; break;
                case "UAE": currency = "AED"; break;
                case "USA": currency = "USD"; break;
                default: currency = "";
            }

            setPyamentSettings(prev => ({
                ...prev,
                PAYTAB_COUNTRY_ONE: value,
                PAYTAB_CURRENCY_ONE: currency
            }));
        } else {
            setPyamentSettings(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    const StorePyamentSetting = async (e) => {
        e.preventDefault();

        try {
            await axios.get('/sanctum/csrf-cookie');
            const response = await axios.post('/api/configuration-setting', {
                eventid,
                settings
            });

            if (response.data.status === 200) {
                await swal({
                    title: 'Success',
                    text: response.data.message,
                    icon: 'success',
                    buttons: {
                        confirm: {
                            text: 'OK',
                            className: 'swal-confirm-button',
                        }
                    }
                });
                history.push('/admin/payment/paytab');
            }
        } catch (error) {
            console.error('Error:', error);
            swal('Error', 'Failed to save settings', 'error');
        }
    };

    const backGroundButtonByEvent = abstractHomeSetup?.color_code_two || '#145348';

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', marginTop: '5%' }}>
                <h4 style={{ display: 'flex', justifyContent: 'flex-end', gap: '1%' }}>
                    <Button
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            "&:hover": { backgroundColor: backGroundButtonByEvent, opacity: 0.9 }
                        }}
                        variant='contained'
                        onClick={() => history.push('/admin/payment/setting')}
                    >
                        Payment Settings
                    </Button>
                     <Button
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            "&:hover": { backgroundColor: backGroundButtonByEvent, opacity: 0.9 }
                        }}
                        variant='contained'
                        onClick={() => history.push('/admin/payment/paytab-two')}
                    >
                     Purplecube USD Payment Settings
                    </Button>
                    
                    <Button
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            "&:hover": { backgroundColor: backGroundButtonByEvent, opacity: 0.9 }
                        }}
                        variant='contained'
                        onClick={() => history.goBack()}
                    >
                        Back
                    </Button>
                </h4>

                <Card sx={{ width: '60vw' }}>
                    <CardContent>
                        <Typography component="h1" variant="h5">
                         Purplecube  AED PayTab Payment settings
                        </Typography>
                        <Box component="form" onSubmit={StorePyamentSetting} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>
                                {/* Country Select */}

                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Country</InputLabel>
                                        <Select
                                            name="PAYTAB_COUNTRY_ONE"
                                            value={settings.PAYTAB_COUNTRY_ONE}
                                            label="Country"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="SAU">Saudi Arabia</MenuItem>
                                            <MenuItem value="ARE">United Arab Emirates</MenuItem>
                                            <MenuItem value="USA">United States</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Merchant Email */}
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Merchant Email"
                                        name="PAYTAB_MERCHANT_EMAIL_ONE"
                                        value={settings.PAYTAB_MERCHANT_EMAIL_ONE}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                {/* Secret Key */}
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Secret Key"
                                        name="PAYTAB_SECRET_KEY_ONE"
                                        value={settings.PAYTAB_SECRET_KEY_ONE}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                {/* Merchant ID */}
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Merchant ID"
                                        name="PAYTAB_MERCHANT_ID_ONE"
                                        value={settings.PAYTAB_MERCHANT_ID_ONE}
                                        onChange={handleChange}
                                    />
                                </Grid>

                                {/* Currency Select */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Currency</InputLabel>
                                        <Select
                                            name="PAYTAB_CURRENCY_ONE"
                                            value={settings.PAYTAB_CURRENCY_ONE}
                                            label="Currency"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="SAR">Saudi Riyal (SAR)</MenuItem>
                                            <MenuItem value="AED">UAE Dirham (AED)</MenuItem>
                                            <MenuItem value="USD">US Dollar (USD)</MenuItem>
                                        </Select>
                                        <Typography variant="caption" color="textSecondary">
                                            Automatically set based on country selection
                                        </Typography>
                                    </FormControl>
                                </Grid>

                                {/* Tax Rate */}
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Tax Rate"
                                        name="PAYTAB_TAX_ONE"
                                        value={settings.PAYTAB_TAX_ONE}
                                        onChange={handleChange}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                    />
                                </Grid>

                                {/* Mode Select */}
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Mode</InputLabel>
                                        <Select
                                            name="PAYTAB_MODE_ONE"
                                            value={settings.PAYTAB_MODE_ONE}
                                            label="Mode"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={1}>Online</MenuItem>
                                            <MenuItem value={0}>Offline</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {/* Status Select */}
                                {/* <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Online Status</InputLabel>
                                        <Select
                                            name="PAYTAB_STATUS_One"
                                            value={settings.PAYTAB_STATUS_One}
                                            label="Online Status"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>Inactive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid> */}

                                {/* Bank Status */}
                                {/* <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Bank Status</InputLabel>
                                        <Select
                                            name="BANK_STATUS_One"
                                            value={settings.BANK_STATUS_One}
                                            label="Bank Status"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>Inactive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid> */}

                                {/* Cash Status */}
                                {/* <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Cash Status</InputLabel>
                                        <Select
                                            name="CASH_STATUS_One"
                                            value={settings.CASH_STATUS_One}
                                            label="Cash Status"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>Inactive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid> */}

                                {/* Free Status */}
                                {/* <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Free Status</InputLabel>
                                        <Select
                                            name="FREE_STATUS_One"
                                            value={settings.FREE_STATUS_One}
                                            label="Free Status"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>Inactive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid> */}
                            </Grid>

                            <Box sx={{ mt: 5, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ backgroundColor: backGroundButtonByEvent }}
                                >
                                    Submit
                                </Button>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
};

export default PayTabOne;